import { FunctionComponent } from 'react'

import AuthorsWithoutImages from '@widgets/Author/Common/AuthorsWithoutImages'
import GridContainer from '@widgets/Author/Common/GridContainer'
import MultipleAuthorsWrapper from '@widgets/Author/MultipleAuthors'
import SingleAuthorWrapper from '@widgets/Author/SingleAuthors'
import { shouldDisplayImages } from '@widgets/Author/utils'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

import { AuthorAPIProps } from './types'

const Author: FunctionComponent<AuthorAPIProps> = ({
  authors,
  type,
  contentOriginImage,
  contentOriginImageDark,
  contentOrigin,
}) => {
  if (!authors?.length) {
    return null
  }
  if (type === 'team') {
    return <GridContainer>{authors}</GridContainer>
  }
  const isSingleAuthor = authors.length === 1

  if (isSingleAuthor) {
    return (
      <SingleAuthorWrapper
        {...authors[0]}
        {...{ contentOrigin, contentOriginImage, contentOriginImageDark }}
      />
    )
  }
  if (!shouldDisplayImages(authors)) {
    return (
      <AuthorsWithoutImages
        {...{ contentOrigin, contentOriginImage, contentOriginImageDark }}
      >
        {authors}
      </AuthorsWithoutImages>
    )
  }

  return (
    <MultipleAuthorsWrapper
      {...{ contentOrigin, contentOriginImage, contentOriginImageDark }}
    >
      {authors}
    </MultipleAuthorsWrapper>
  )
}

const widget = {
  kind: ['widget', 'inlineElement', 'author'],
  component: Author,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
